// extracted by mini-css-extract-plugin
module.exports = {"text":"ModalTextPrimary_text__dzV8G"};